// extracted by mini-css-extract-plugin
export default {"-large":"WYvJPvffqONyj6gHals7","premiumIconColor":"p3U8XAUImIyr0sRhwnS7"};